'use strict';

exports.__esModule = true;
exports.DEFAULT_COMPONENT_PROP_NAMES = exports.RouteDispatcher = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _reactRouterConfig = require('react-router-config');

var _history = require('history');

var _dispatchRouteActions = require('./dispatchRouteActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/prop-types */
function isDispatchActionsEqual(arr1, arr2) {
    // Determine if a function was passed.
    var isFunc1 = typeof arr1 === 'function';
    var isFunc2 = typeof arr2 === 'function';
    if (isFunc1 || isFunc2) {
        if (isFunc1 !== isFunc2) {
            return false;
        }

        return arr1 === arr2;
    }

    // It should be an array
    if (arr1.length !== arr2.length) {
        return false;
    }

    for (var idx = 0, len = arr1.length; idx < len; idx++) {
        var item1 = arr1[idx];
        var item2 = arr2[idx];

        var isArray1 = Array.isArray(item1);
        if (isArray1 !== Array.isArray(item2)) {
            return false;
        }

        if (isArray1) {
            if (!isDispatchActionsEqual(item1, item2)) {
                return false;
            }
        } else {
            for (var j = 0, _len = item1.length; j < _len; j++) {
                if (item1[j] !== item2[j]) {
                    return false;
                }
            }
        }
    }

    return true;
}

var _ref = (0, _jsx3.default)('div', {}, void 0, 'Loading...');

var DefaultLoadingIndicator = function DefaultLoadingIndicator() {
    return _ref;
};

var DEFAULT_COMPONENT_PROP_NAMES = ['component', 'components'];

var RouteDispatcher = function (_Component) {
    (0, _inherits3.default)(RouteDispatcher, _Component);

    RouteDispatcher.dispatchServerActions = function dispatchServerActions(location, actionNames, routeCfg, props) {
        return (0, _dispatchRouteActions.dispatchServerActions)(location, actionNames, routeCfg, props);
    };

    RouteDispatcher.dispatchClientActions = function dispatchClientActions(location, actionNames, routeCfg, props) {
        return (0, _dispatchRouteActions.dispatchClientActions)(location, actionNames, routeCfg, props);
    };

    RouteDispatcher.componentDispatch = function componentDispatch(actionNames, props) {
        var location = props.location,
            routes = props.routes,
            routeComponentPropNames = props.routeComponentPropNames,
            actionParams = props.actionParams;

        return (0, _dispatchRouteActions.dispatchComponentActions)(location, actionNames, { routes: routes, routeComponentPropNames: routeComponentPropNames }, (0, _assign2.default)({}, actionParams));
    };

    function RouteDispatcher(props, context) {
        (0, _classCallCheck3.default)(this, RouteDispatcher);

        var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props, context));

        _this.state = {
            previousLocation: null,
            hasDispatchedActions: !props.dispatchActionsOnFirstRender,
            dispatchActionNames: (0, _dispatchRouteActions.standardizeActionNames)(props.actionNames)
        };
        return _this;
    }

    RouteDispatcher.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        var _state = this.state,
            hasDispatchedActions = _state.hasDispatchedActions,
            dispatchActionNames = _state.dispatchActionNames;

        if (hasDispatchedActions) {
            // data is already loaded
            return;
        }

        RouteDispatcher.componentDispatch(dispatchActionNames, this.props).then(function () {
            // re-render after data has loaded
            _this2.setState({ hasDispatchedActions: true });
        });
    };

    RouteDispatcher.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this3 = this;

        var _props = this.props,
            location = _props.location,
            actionNames = _props.actionNames;
        var nextLocation = nextProps.location,
            nextActionNames = nextProps.actionNames;


        var nextState = void 0;
        if (typeof nextLocation !== 'undefined' && (0, _history.createPath)(nextLocation) !== (0, _history.createPath)(location)) {
            nextState = { previousLocation: location };
        }

        if (typeof nextActionNames !== 'undefined' && actionNames !== nextActionNames) {
            var nextDispatchActionNames = (0, _dispatchRouteActions.standardizeActionNames)(nextActionNames);
            if (!isDispatchActionsEqual(this.state.dispatchActionNames, nextDispatchActionNames)) {
                nextState = {
                    dispatchActionNames: nextDispatchActionNames,
                    previousLocation: location
                };
            }
        }

        if (typeof nextState !== 'undefined') {
            this.setState(nextState);

            // load data while the old screen remains
            RouteDispatcher.componentDispatch(nextActionNames, nextProps).then(function () {
                // clear previousLocation so the next screen renders
                _this3.setState({ previousLocation: null });
            });
        }
    };

    RouteDispatcher.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var hasLocationChanged = nextState.previousLocation === null && this.state.previousLocation !== null;
        var haveActionParamsChanged = this.props.actionParams !== nextProps.actionParams;
        return hasLocationChanged || haveActionParamsChanged;
    };

    RouteDispatcher.prototype.render = function render() {
        var _props2 = this.props,
            location = _props2.location,
            routes = _props2.routes,
            _render = _props2.render,
            loadingIndicator = _props2.loadingIndicator,
            actionNames = _props2.actionNames,
            routeComponentPropNames = _props2.routeComponentPropNames,
            dispatchActionsOnFirstRender = _props2.dispatchActionsOnFirstRender,
            actionParams = _props2.actionParams,
            match = _props2.match,
            history = _props2.history,
            routeProps = (0, _objectWithoutProperties3.default)(_props2, ['location', 'routes', 'render', 'loadingIndicator', 'actionNames', 'routeComponentPropNames', 'dispatchActionsOnFirstRender', 'actionParams', 'match', 'history']);


        if (!this.state.hasDispatchedActions) {
            // Display a loading indicator until data is loaded
            return _react2.default.isValidElement(loadingIndicator) || typeof loadingIndicator === 'function' ? _react2.default.createElement(loadingIndicator) : (0, _jsx3.default)('div', {}, void 0, loadingIndicator);
        }

        return (0, _jsx3.default)(_reactRouter.Route, {
            location: this.state.previousLocation || location,
            render: function render() {
                return _render(Array.isArray(routes) ? routes : null, routeProps);
            }
        });
    };

    return RouteDispatcher;
}(_react.Component);

RouteDispatcher.defaultProps = {
    actionParams: {},
    routeComponentPropNames: DEFAULT_COMPONENT_PROP_NAMES,
    dispatchActionsOnFirstRender: true,
    loadingIndicator: DefaultLoadingIndicator,
    render: function render(routes, routeProps) {
        return (0, _reactRouterConfig.renderRoutes)(routes, routeProps);
    }
};


var RouterDispatcher = (0, _reactRouter.withRouter)(RouteDispatcher);

exports.RouteDispatcher = RouteDispatcher;
exports.DEFAULT_COMPONENT_PROP_NAMES = DEFAULT_COMPONENT_PROP_NAMES;
exports.default = RouterDispatcher;